import { render } from "./Cropper.component.vue?vue&type=template&id=6fc986cf"
import script from "./Cropper.component.vue?vue&type=script&lang=js"
export * from "./Cropper.component.vue?vue&type=script&lang=js"

import "./Cropper.component.vue?vue&type=style&index=0&id=6fc986cf&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QFooter,QBtn});
